import { BehaviorSubject } from 'rxjs';

export class ProgresoEndPoint<T> {
  public subjects: Map<string, BehaviorSubject<T>> = new Map<string, BehaviorSubject<T>>();
  public name: string;
  public path: string;
  public timesRefreshed = 0;
  public timesCalled = 0;
  public lastData: any = null;
  public lastResult$: BehaviorSubject<T> = new BehaviorSubject<T>(undefined);
  public cacheable: boolean;
  public relations: string[] = [];

  public constructor(name: string, path: string, cacheable: boolean, relations: string[]) {
    this.name = name;
    this.path = path;
    this.cacheable = cacheable;
    this.relations = relations;
  }
}
